import { APIS } from '@/utilities/constants';
import axiosInstance from '@/services';
import { LocalStorageService } from 'br2s-ui-common-utils-02';

export const inboxAPI = {
  /**
   * API service to get /api/v1/inbox/unreadMessages
   * @param params string
   * @returns totalCount
   */
  notifCount: async () => {
    const { uen, origin } = LocalStorageService.getAuthInfo('uen', 'origin');
    const params = origin !== 'SP' ? { uen } : {};

    const response = await axiosInstance.get(APIS.INBOX_COUNT, { params });
    return response;
  },
};
